import { RouteConfig } from 'config/constants/route'
import { getCustomMeta } from 'config/meta'
import { buildSeoProps, fetchMetaTag } from 'services/serverSide/metaTag'
import { ServerTranslator } from 'services/serverSide/serverTranslator'
import Games from 'views/Games'

export async function getServerSideProps({ query, locale }) {
  await ServerTranslator.init()
  const metaTag = await fetchMetaTag(RouteConfig.Games, locale)

  if (query.tag) {
    return {
      redirect: {
        statusCode: 301,
        destination: `/games/${query.tag}`,
      },
    }
  }

  return {
    props: {
      seoProps: buildSeoProps(metaTag, getCustomMeta(RouteConfig.Games, ServerTranslator.buildTFn(locale), locale)),
    },
  }
}

export default Games
